/**
 * Fetch storefront HTML and cart data only from this store's origin.
 * Scoped to the theme callers; browser fetch and app requests are unchanged.
 */
function themeStoreFetch(input, init) {
  return Promise.resolve().then(function () {
    var isRequest = typeof Request !== 'undefined' && input instanceof Request;
    var target = new URL(isRequest ? input.url : String(input), window.location.href);
    if ((target.protocol !== 'https:' && target.protocol !== 'http:') || target.origin !== window.location.origin) {
      throw new TypeError('Theme requests must use this store\'s origin.');
    }
    // The browser also rejects a redirect to a different origin in this mode.
    var options = Object.assign({}, init, { mode: 'same-origin' });
    return window.fetch(isRequest ? input : target.href, options);
  });
}
